/* Client-side mirror of the API's upload rule (App\Rules\SafeUploadedFile).
 *
 * The server is the authority — this only exists so the answer arrives before
 * the file does. Without it, picking a 60MB video means waiting out the whole
 * upload to be told no, and picking an .html means a rejection with no hint of
 * which file caused it.
 *
 * Keep the two lists in step. A file the server rejects and this lets through
 * is a slow error message; a file this rejects and the server would have taken
 * is a feature quietly lost, which is worse — so when in doubt, allow it here
 * and let the API decide.
 */

/* Runs on the server, or in the viewer's browser on our own origin. */
const BLOCKED_EXTENSIONS = new Set([
  "php", "php2", "php3", "php4", "php5", "php6", "php7", "php8",
  "phps", "phtml", "phtm", "pht", "phar", "inc",
  "asp", "aspx", "ashx", "asmx", "cer",
  "jsp", "jspx", "jsw", "jsv", "jspf",
  "cgi", "pl", "py", "rb", "sh", "bash", "ksh", "csh",
  "exe", "com", "bat", "cmd", "msi", "scr", "vbs", "ps1", "jar",
  "htaccess", "htpasswd", "user",
  "html", "htm", "xhtml", "xht", "shtml", "shtm",
  "svg", "svgz", "xml", "xsl", "xslt",
  "js", "mjs", "cjs", "jsx", "hta", "swf",
]);

export const MAX_UPLOAD_MB = 50;

/* Every dot-separated segment, the same way the server checks: `note.php.jpg`
   ends in .jpg and still runs under a misconfigured Apache. */
const hasBlockedExtension = (name) =>
  String(name || "")
    .toLowerCase()
    .replace(/^\.+/, "")
    .split(".")
    .filter(Boolean)
    .some((segment) => BLOCKED_EXTENSIONS.has(segment));

/**
 * @returns {string|null} a Persian reason to show the user, or null if the file
 *   looks acceptable.
 */
export const uploadRejectionReason = (file, maxMb = MAX_UPLOAD_MB) => {
  if (!file) return null;

  if (typeof file.size === "number" && file.size > maxMb * 1024 * 1024) {
    return `حجم فایل نباید بیشتر از ${maxMb} مگابایت باشد.`;
  }

  if (hasBlockedExtension(file.name)) {
    return "این نوع فایل قابل بارگذاری نیست.";
  }

  return null;
};

export default uploadRejectionReason;
